import { injectIntl } from "react-intl";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Box from "src/components/Box";
import ListSelect from "src/components/ListSelect";
import apiService from "src/services/api.service";

const SpecificCalendarHeader = (props) => {

    const [lists, setLists] = useState([])
    const [openLists, setOpenLists] = useState(false)
    const navigate = useNavigate();
    const divRef = useRef(null);

    useEffect(() => {
        apiService.getAllLists().then((response) => setLists(response.data))
    }, [])

    const handleClickOutside = useCallback((event) => {
        if (divRef.current && !divRef.current.contains(event.target)) {
            setOpenLists(false)
        }
    }, []);

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [handleClickOutside]);

    const handleChosenList = (id) => {
        props.setChosenList(id)
        setOpenLists(false)
        props.setIsUpdate(true)
    };

    const handleRight = () => {
        const index = lists.findIndex(item => item._id === props.chosenList?._id)
        if (index !== -1 && index < lists.length - 1) {
            props.setChosenList(lists[index + 1])
        }
    };

    const handleLeft = () => {
        const index = lists.findIndex(item => item._id === props.chosenList?._id)
        if (index > 0) {
            props.setChosenList(lists[index - 1])
        }
    };

    return (
        <div className={ "PageHeader" }>
            <div className={ "flex gap-3" }>
                <div className={ "flex gap-3" }>
                    <button className={ "SecondaryButton" } onClick={ () => navigate("/allCalendar") }>
                        <img alt={ "Logo" } src={ "/media/icons/arrowLeft.svg" } className={ "w-4 h-4" }/>
                        Back
                    </button>
                </div>
                <div className={ "SearchLineDivider" }></div>
                <div className={ "flex gap-2 items-center" }>
                    <button className={ "ListChooseChevronButton" } onClick={ () => handleLeft() }>
                        <img alt={ "Logo" } src={ "/media/icons/chevronLeft.svg" } className={ "w-[18px] h-[18px]" }/>
                    </button>
                    <div ref={ divRef } >
                        { openLists ?
                            <ListSelect setOpenSelect={ setOpenLists } selectedItem={ props.chosenList }
                                        selectItem={ handleChosenList }
                                        list={ lists } setOpenLists={ setOpenLists }></ListSelect> :
                            <button className={ "ListChooseButton" } onClick={ () => setOpenLists(true) }>
                                <div className={ "flex gap-1 items-center" }>
                                    <img alt={ "Logo" }
                                         src={ "/media/icons/rows.svg" }
                                         className={ "w-[14px] h-[14px]" }/>
                                    <div className={ "DashboardListNameTitle" }>List Name:</div>
                                </div>
                                <Box name={ props.chosenList?.type }/>
                                <div className={ "DashboardListName" }>{ props.chosenList?.name }</div>
                                <img alt={ "Logo" } src={ "/media/icons/chevronDown.svg" }
                                     className={ "w-[18px] h-[18px]" }/>
                            </button>
                        }
                    </div>
                    <button className={ "ListChooseChevronButton" } onClick={ () => handleRight() }>
                        <img alt={ "Logo" } src={ "/media/icons/chevronRight.svg" } className={ "w-[18px] h-[18px]" }/>
                    </button>
                </div>
            </div>
            <button className={ "PrimaryButton" } onClick={ () => props.setOpenNewSchedule(true) }>
                <img alt={ "Logo" } src={ "/media/icons/plusIcon.svg" } className={ "w-4 h-4" }/>
                New Schedule
            </button>
        </div>
    )
}

export default injectIntl(SpecificCalendarHeader)